import { apiClient, Auth } from '@/shared/api'

import { TCheckInChecklist } from '../model/schema'

export const getCheckInChecklist = async (initialContractId: number) => {
  const { data } = await apiClient.get<TCheckInChecklist>({
    endpoint: `/guest/contracts/${initialContractId}/check-in/checklist`,
    auth: Auth.REQUIRED,
  })

  return data
}
